/* eslint-disable prettier/prettier */
import React from 'react';
import Head from 'next/head';
import { Product } from '@Types/product/Product';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart } from 'frontastic';
import ListItem from './list-item';

interface Props {
  products: Product[];
  filtering?: boolean;
  isPreview?: boolean;
  previewURL?: string;
}

const List: React.FC<Props> = ({ products, filtering, isPreview, previewURL }) => {
  //i18n messages
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  const { data } = useCart();

  return (
    <>
      <h2 className="sr-only">{formatProductMessage({ id: 'products', defaultMessage: 'Products' })}</h2>
      <div className="list-items">
        {products?.map((product) => (
          <ListItem product={product} key={product.productId} isPreview={isPreview} previewURL={previewURL} />
        ))}
      </div>
    </>
  );
};

export default List;
